import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  bottom: -37.5px;
  right: -37.5px;
  display: flex;
  flex-direction: column;
  align-self: stretch;

  label {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }

    img,
    div {
      width: 10rem;
      height: 10rem;
      border: 0;
      object-fit: contain;

      padding: 0.8rem;

      background: ${(props) => props.theme.colors.primary};
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      border-radius: 1.5rem;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      svg {
        width: 40px;
        height: 40px;

        color: #dddddd;
      }

      strong {
        font-size: 1.2rem;
        text-align: center;

        color: #dddddd;

        margin-top: 0.2rem;
      }
    }

    input {
      display: none;
    }
  }

  > button {
    font-size: 1.5rem;
    text-align: left;

    color: ${({ theme }) => theme.colors.text.cards};

    width: 100%;
  }
`
